import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';

function Navbar({ children }) {
  const navigate = useNavigate();

  return (
    <nav className="top-navbar">
      <div className="nav-container">
        <div className="nav-logo" onClick={() => navigate('/')}>
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Klinik" className="logo-img" />
        </div>
        {children}
      </div>
    </nav>
  );
}

export default Navbar;